// src/components/prescriptions/ImageUpload.jsx
import React, { useRef } from "react";
import api from "../../services/api";

/**
 * Componente simples de upload com preview imediato (dataURL).
 * Tenta (opcionalmente) enviar via multipart para /uploads/images caso exista no backend
 * e, se o backend retornar { url }, troca o dataURL pela URL pública.
 */
export default function ImageUpload({
  label = "Enviar imagem",
  value,
  onChange,
  accept = "image/*",
  field = "file",
}) {
  const inputRef = useRef(null);
  const openPicker = () => inputRef.current?.click();

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // 1) Preview imediato (dataURL), para o usuário ver na hora
    const reader = new FileReader();
    reader.onload = () => onChange?.(reader.result);
    reader.readAsDataURL(file);

    // 2) Upload opcional via multipart (se o endpoint existir)
    try {
      const form = new FormData();
      form.append(field, file);
      const { data } = await api.post("/uploads/images", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (data?.url) onChange?.(data.url);
    } catch (err) {
      // É opcional: se não existir o endpoint, tudo segue com o dataURL
      console.debug("Upload opcional falhou (ignorado):", err?.message);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <button type="button" onClick={openPicker} className="px-3 py-2 border rounded-md">
        {label}
      </button>
      {value && <img src={value} alt="preview" className="h-10 object-contain border rounded" />}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        onChange={onFile}
      />
    </div>
  );
}